import { crmAxios } from '@/utils/Axios';
import { UPDATE_LOADING_STATE } from '@/constants/mutation-types';

const isEmptyResponse = (data) => {
  if (data == null) return true;
  if (typeof data === 'string') return !data.trim();
  if (Array.isArray(data)) return data.length === 0;
  if (typeof data === 'object') return Object.keys(data).length === 0;
  return false;
};

export default ({ commit }, since) => {
  commit(UPDATE_LOADING_STATE, true);


  return crmAxios({
    method: 'get',
    url: `/Contact/voorlichterhistory/?since=${since}`,
    headers: { Accept: 'application/json' },
  })
    .then((resp) => {
      const { data, status } = resp || {};

      if (isEmptyResponse(data)) {
        return { error: false, empty: true, data: null };
      }

      if (typeof data === 'string') {
        try {
          const parsed = JSON.parse(data);
          return { error: false, empty: false, data: parsed };
        } catch (err) {
          console.error(`[Contact History] failed to parse string response since ${since}`, err);
          throw new Error(`Failed to parse Contact History response since ${since}`);
        }
      }

      return { error: false, empty: false, data };
    })
    .catch((err) => {
      console.error('[Contact History] request error', err);
      throw err;
    })
    .finally(() => {
      commit(UPDATE_LOADING_STATE, false);
    });
};